import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	tableContainer: { height: 600, width: '100%', marginTop: theme.spacing(5) },
	datagrid: { height: 500, width: '100%' },
	root: {
		display: 'flex',
	},
}));
